import { Link } from "react-router-dom";
import { Shield, Mail, Phone, MapPin } from "lucide-react";

const cols = [
  {
    title: "Company",
    links: [
      { label: "About Us", to: "/about" },
      { label: "How It Works", to: "/#how-it-works" },
      { label: "Careers", to: "/careers" },
      { label: "Press", to: "/press" },
    ],
  },
  {
    title: "Services",
    links: [
      { label: "File a Claim", to: "/file-claim" },
      { label: "Track Claim", to: "/track" },
      { label: "Emergency Assistance", to: "/emergency" },
      { label: "Cashless Repairs", to: "/knowledge/cashless-claim-guide" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Knowledge Center", to: "/knowledge" },
      { label: "Accident Checklist", to: "/knowledge/accident-checklist" },
      { label: "Claim Process", to: "/knowledge/motor-claim-process" },
      { label: "FAQs", to: "/knowledge" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Terms of Service", to: "/legal/terms" },
      { label: "Privacy Policy", to: "/legal/privacy" },
      { label: "Disclaimer", to: "/legal/disclaimer" },
      { label: "Grievance", to: "/legal/grievance" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300 border-t border-slate-800" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl overflow-hidden shadow-lg shadow-blue-700/20">
                <img src="/brand/logo.webp" alt="myinsuranceclaim.in" className="w-full h-full object-cover" />
              </div>
              <div className="font-heading font-extrabold text-lg text-white">
                myinsuranceclaim<span className="text-orange-400">.in</span>
              </div>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed mb-4">
              India's first independent motor insurance claim assistance platform.
              Not an insurance company. We help you file, track and settle claims faster.
            </p>
            <div className="flex flex-col gap-2 text-sm">
              <a href="mailto:help@myinsuranceclaim.in" className="flex items-center gap-2 hover:text-white">
                <Mail className="w-4 h-4" /> help@myinsuranceclaim.in
              </a>
              <a href="tel:+919942249388" className="flex items-center gap-2 hover:text-white">
                <Phone className="w-4 h-4" /> +91 99422 49388 (24×7)
              </a>
              <span className="flex items-center gap-2 text-slate-400">
                <MapPin className="w-4 h-4" /> India · 1000+ cities
              </span>
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-heading font-bold text-white mb-3 text-sm uppercase tracking-wider">{c.title}</h4>
              <ul className="space-y-2">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-sm text-slate-400 hover:text-white transition-colors" data-testid={`footer-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col md:flex-row justify-between items-start md:items-center gap-3">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} myinsuranceclaim.in — A claim assistance platform. We are not an insurance company.
          </p>
          <p className="text-xs text-slate-500">Built with ❤︎ in India</p>
        </div>
      </div>
    </footer>
  );
}
